import { withModalProvider } from "../../hoc/withModalProvider";

import { PlacementWorksheetSettings as View } from "./PlacementWorksheetSettings";

export const PlacementWorksheetSettings = withModalProvider(View);
